import { Component, OnInit,Input } from '@angular/core';
import { NgbModal, NgbModalRef, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TenderPlaceBidComponent } from '../tender-place-bid/tender-place-bid.component';
import { CustomProductsService } from 'src/app/modules/custom-landing/custom-products/custom-products.service'
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import moment from 'moment';
import { ToastService } from 'src/app/core/services/toaster.service';
import { NgIf, NgFor, DecimalPipe, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { I18nModule } from '@spartacus/core';
@Component({
    selector: 'app-tender-confirm-bid-modal',
    templateUrl: './tender-confirm-bid-modal.component.html',
    styleUrls: ['./tender-confirm-bid-modal.component.scss'],
    imports: [NgIf, NgFor, FormsModule, DecimalPipe, DatePipe, I18nModule]
})
export class TenderConfirmBidModalComponent implements OnInit {
  @Input() finalQPFromDate:any;
  @Input() finalQPToDate:any;
  private modalRef: NgbModalRef;
  COI: boolean =false;
  OpenNegotiation:boolean=true;
  @Input() quantity:any;
  @Input() code:any;
  @Input() price:any;
  @Input() tabName: any;
  @Input() indexPrice:number;
  @Input() datePeriod:any;
  @Input() selectProduct:any;
  reqTenderEntries:any = [];
  combinedchildlist:any = [];
  priceTab:any;
  productInfo:any;
  product:any;
  tabValue: any;
  biddingTerms = '';
  requestParams: any;
  enableLoader: boolean = false;
  @Input() quantityshw:any;
  @Input() dischargePortshw:any;
  @Input() screen:any;
  confirmTxt: string = null;

  constructor(private router: Router ,public activeModal: NgbActiveModal,private Modal:NgbModal,
    private customProductsService: CustomProductsService, private toastrService: ToastrService) { }

  ngOnInit(): void {
    console.log(this.quantity,'quantity')
    console.log(this.screen,'screen')
      this.product=this.datePeriod;
    this.customProductsService.getConfirmtxt().subscribe((txt)=>{
        this.confirmTxt = txt;
   })
    if(this.datePeriod?.tenderEntries?.length ==1){
    this.productInfo=this.code;
    console.log(this.productInfo, "prod");
    
  }else{
    if(this.code.length==1){
      this.productInfo=this.code[0];
    }else{
      this.productInfo=this.code;
    }
  }
    this.tabValue = this.tabName;
    console.log(this.tabName,'pricingoption')
    if(this.datePeriod.groupTenders){
      this.datePeriod.combinedchildlist=[...this.productInfo.childList]
  }
    if(this.datePeriod.combinedchildlist){
      console.log("in if");
      
      this.datePeriod.combinedchildlist.map((val)=>{
        this.reqTenderEntries.push({ 
              "entryNumber": val.entryNumber,
              "finalQPFromDate":val.isQuotationPeriodUnrestricted==true || val.isQPMultipleChoicesSelected == true?val.finalQPFromDate:'',
            "finalQPToDate":val.isQuotationPeriodUnrestricted==true || val.isQPMultipleChoicesSelected == true?val.finalQPToDate:'',
                  "pricingOptionsEnum": [
                      {
                        "pricingOptions": this.tabName !='none' ? this.tabName : this.productInfo.pricingOptionsEnum[0].pricingOptions,
                        "qpMultipleChoices": this.productInfo.pricingOptionsEnum[0].qp
                      }
                    ],
                  "productCode":  val.productCode,
                  "qpMultipleChoices": this.productInfo.pricingOptionsEnum[0].qp,
                [this.tabName=='FIXED_PRICE'? 'relativePrice' : 'premiumDiscount']: {
                  "currencyIso": "USD",
                  "value":this.tabName=='FIXED_PRICE' ? (val.FixedPrice?val.FixedPrice:val.price) : val.IndexPrice?val.IndexPrice:val.price,
                }, "quantity": this.productInfo?.isQuantityUnrestricted== true? this.productInfo.quantity: this.productInfo.quantity
          })
      }) 
 
    }else{
      console.log("in else");
      
      this.requestParams = {
        "quoteAction": this.screen=='placebid'?"BID_PLACED":'EDIT_BID',
        "tender": {
    //      "otherBindingTerms": this.biddingTerms,   
          "quoteCode": this.product.quoteCode,
          "tenderEntries": [
            {  "entryNumber": this.productInfo.entryNumber,
              "finalQPFromDate":this.productInfo.isQuotationPeriodUnrestricted==true || this.productInfo.isQPMultipleChoicesSelected == true?this.productInfo.finalQPFromDate:'',
              "finalQPToDate":this.productInfo.isQuotationPeriodUnrestricted==true || this.productInfo.isQPMultipleChoicesSelected == true?this.productInfo.finalQPToDate:'',
              "productCode":  this.productInfo.productCode,
              "qpMultipleChoices": this.productInfo.pricingOptionsEnum[0].qp,
              "pricingOptionsEnum":[
                {
                  "pricingOptions":this.tabName !='none' ? this.tabName : this.productInfo.pricingOptionsEnum[0].pricingOptions,
                  "qpMultipleChoices": this.productInfo.pricingOptionsEnum[0].qp
                }
              ],
              [this.product.commodityType=='CN' ?"rcPrice":this.productInfo.pricingOptionsEnum[0].pricingOptions=='FIXED_PRICE'? 'relativePrice' : 'premiumDiscount']: {
                "currencyIso": "USD",
                "value":this.product.commodityType=='CN'? (this.productInfo.displayRCPriceConfig.displayRCPrice == true ? this.indexPrice : ""):this.price,
              },
              [this.product.commodityType=='CN'?"tcPrice":'tcPrice']: {
                "currencyIso":"USD",
                "value": this.product.commodityType=='CN'?this.price:'',
              },
             "quantity": this.productInfo?.isQuantityUnrestricted== true? this.productInfo.quantity: this.productInfo.quantity
            }
          ]
        }
}
    }
 
  }
  convertingDateOnly(dateString,timezone): any {
    if (dateString) {
      return moment.parseZone(dateString).utcOffset(timezone.timeZoneFormat).format('DD/MM/YYYY HH:mm');
      }else{
        return '';
      }  }
  submitBid(): any {
    if(this.datePeriod.groupTenders){
      this.requestParams={
        "quoteAction": "BID_PLACED",
      "tender": {
        "buyerRemarks": this.biddingTerms,   
        "quoteCode": this.product.quoteCode,
        "tenderEntries": this.reqTenderEntries
      }
    }
    }  
    if(this.productInfo.minimumQuantity && this.productInfo.maximumQuantity){
     this.requestParams.tender.tenderEntries[0].quantity=this.quantity
    }
    if(this.productInfo.isQuantityUnrestricted == true){
      this.requestParams.tender.tenderEntries[0].quantity = this.quantityshw; 
    }
    if(this.productInfo.isDischargePortUnrestricted == true){
      this.requestParams.tender.tenderEntries[0].dischargePortDetails = this.dischargePortshw; 
    }
    if(this.productInfo.isQuotationPeriodUnrestricted== true){
      this.requestParams.tender.tenderEntries[0].finalQPFromDate=this.finalQPFromDate
      this.requestParams.tender.tenderEntries[0].finalQPToDate=this.finalQPToDate
    }
    if(this.productInfo.pricingOptionsEnum.length>0){
      if(this.tabName ){
        if(this.tabName!='FIXED_PRICE'){
          delete this.requestParams.tender.tenderEntries[0].relativePrice
          this.requestParams.tender.tenderEntries[0].premiumDiscount = new Object({'currencyIso':'USD','value':this.price});
        }
      }
    }
    // if (this.product.commodityType == 'IO') {
    //   if(this.requestParams.tender.tenderEntries[0].premiumDiscount){
    //     if (this.requestParams.tender.tenderEntries[0].premiumDiscount?.value == '' || this.requestParams.tender.tenderEntries[0].premiumDiscount?.value == undefined) {
    //       this.requestParams.tender.tenderEntries[0].premiumDiscount.value = 0;
    //     }
    //   }
    // }
    for (let data of this.reqTenderEntries) {
      if (this.product.commodityType != 'CN') {
        delete data.tcPrice
        delete data.rcPrice
      }
      if (this.product.commodityType == 'IO') {
        if (data.premiumDiscount){
          if (data.premiumDiscount?.value == '' || data.premiumDiscount?.value == undefined) {
            data.premiumDiscount.value = 0;
          }
        }
      }
    }
    if(this.product.commodityType=='CN' ){
        if(this.productInfo.displayRCPriceConfig.displayRCPrice == false){
        delete this.requestParams.tender.tenderEntries[0].rcPrice
      }
    }
    if(this.product.commodityType=='CA' && this.tabName=='FLOATING_PREMIUM'){
      delete this.requestParams.tender.tenderEntries[0].premiumDiscount;
    }
   // this.requestParams.tender.tenderEntries[0].relativePrice.value = parseFloat(this.price);
    this.requestParams.tender.buyerRemarks = this.biddingTerms;
    console.log(this.requestParams,'req');
    this.enableLoader = true;
    this.customProductsService.submitTender(this.requestParams).subscribe(resp=>{
      console.log(resp);
      if(resp.status === 'BID_PLACED'){
        this.enableLoader = false;
        this.toastrService.show(resp.status);
        this.activeModal.close();
        if(this.screen == 'placebid'){
          this.router.navigate([`/quotes/myquotes`]);
        }else{
          this.customProductsService.bidPlaced = true;
          const currentUrl = this.router.url;
          if (currentUrl === '/quotes/myquotes') {
            this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
              this.router.navigate([currentUrl]);
          });
          }else{
            this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
              this.router.navigate([currentUrl] );
            });
          }
        }
      }else{
        this.enableLoader = false;
        this.toastrService.show(resp.status?resp.status:"Sorry something went wrong!");
      }
    },
    err=>{
      this.enableLoader = false;
      this.activeModal.close();
      this.toastrService.show(err?.error.errors?err.error.errors[0].message:'Something went wrong while submitting the tender, please contact support team');
    })
    
  }
  backToPlacebid(): any{
    this.activeModal.close();
    const ModalRef = this.Modal.open(TenderPlaceBidComponent,{centered: true,size:'md'});
    if (this.product?.length ==1){
      ModalRef.componentInstance.screen=this.screen;
      ModalRef.componentInstance.tabName = this.tabName;
      this.productInfo.finalQPFromDate=this.finalQPFromDate
      this.productInfo.finalQPToDate=this.finalQPToDate
      ModalRef.componentInstance.productsInfo=this.datePeriod;
      ModalRef.componentInstance.quantityshw=this.quantityshw;
      ModalRef.componentInstance.dischargePortshw=this.dischargePortshw;
      ModalRef.componentInstance.finalQPFromDate=this.finalQPFromDate
      ModalRef.componentInstance.finalQPToDate=this.finalQPToDate
      if(this.productInfo.minimumQuantity && this.productInfo.maximumQuantity){
      ModalRef.componentInstance.quantity=this.quantity;
          }
    } else {
      this.productInfo.finalQPFromDate=this.finalQPFromDate
      this.productInfo.finalQPToDate=this.finalQPToDate
      ModalRef.componentInstance.selectProduct = this.datePeriod;
      ModalRef.componentInstance.productsEntry = this.code;
      ModalRef.componentInstance.finalQPFromDate = this.finalQPFromDate
      ModalRef.componentInstance.finalQPToDate = this.finalQPToDate
      ModalRef.componentInstance.quantityshw=this.quantityshw;
      ModalRef.componentInstance.dischargePortshw=this.dischargePortshw;
      if (this.productInfo.minimumQuantity && this.productInfo.maximumQuantity) {
        ModalRef.componentInstance.quantity = this.quantity;
      }
    }
    ModalRef.componentInstance.screen=this.screen;
    if(this.productInfo.pricingOptionsEnum[0]?.qp){
      ModalRef.componentInstance.defaultValue = this.productInfo?.pricingOptionsEnum[0]?.qp[0]?.description;
      if(ModalRef.componentInstance.defaultValue == 'Fixed QP'){
        ModalRef.componentInstance.displayFixedQPSection = true;
        ModalRef.componentInstance.finalQPFromDate=this.productInfo.finalQPFromDate;
        ModalRef.componentInstance.finalQPToDate=this.productInfo.finalQPToDate;
      }else{
        ModalRef.componentInstance.displayFixedQPSection = false;
      }
    }
    ModalRef.componentInstance.tabName = this.tabValue;
    if(this.product.commodityType=='CN'){
      ModalRef.componentInstance.price = this.price;
      ModalRef.componentInstance.indexPrice = this.indexPrice;
    }else{
      if(this.tabValue=='FIXED_PRICE'){
        ModalRef.componentInstance.price = this.price;
      }
      if(this.tabValue=='INDEX_PRICE' || this.tabValue=='LUMP_FIXED_PRICE' ||  this.tabValue=='FIXED_PREMIUM'||this.tabValue=='FLOATING_PREMIUM'){
         ModalRef.componentInstance.indexPrice = this.price;
      }
    }
  }
  getDate(date){
    if(date){
      var formateDate = new Date(date).getDate() + '/' + (new Date(date).getMonth() + 1) + '/' + new Date(date).getFullYear();
      return formateDate;
    }
    else{
      return '';
    }

  }
  formatQPDates(data){
    return this.customProductsService.formatQPDates(data);
  }
  getLabelofConfirmScreen(priceOptions,commodityType,page){
    return this.customProductsService.getLabelofConfirmScreen(priceOptions,commodityType,page);
  }
  getPriceandSymbol(priceOptions,price,commodityType){
  return this.customProductsService.getPriceandSymbol(priceOptions,price,commodityType);
  }
  getPricingBasisBasedOnOption(pricingOption,description){
    return this.customProductsService.getPricingBasisBasedOnOption(pricingOption,description)
  }
}
